"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.setSelection = exports.moveSelection = exports.getActionList = exports.drawAll = exports.getList = exports.getCanPurchaseColor = exports.close = exports.open = exports.isOpen = exports.get = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueHotkeys_sidecar_1 = require("../monofont/rogueHotkeys-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: true,
            highlightedItemIdx: 0,
            highlightedActionIdx: 0,
            selectedItem: null,
        };
    }
    return _obj;
};
exports.get = get;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
    obj.selectedItem = null;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
    obj.selectedItem = null;
    rogueHotkeys_sidecar_1.rogueHotkeys.clearAll();
};
exports.close = close;
var _actionUsed = false;
var getCanPurchaseColor = function (item) {
    var color = rogueDef_sidecar_1.rogueDef.colors.light;
    if (!item.isBought) {
        color = rogueDef_sidecar_1.rogueDef.colors.orange;
        if (rogueStats_sidecar_1.rogueStats.getStats().skillPoints < item.cost) {
            color = rogueDef_sidecar_1.rogueDef.colors.red;
        }
    }
    return color;
};
exports.getCanPurchaseColor = getCanPurchaseColor;
var getList = function () {
    var list = [];
    var items = rogueSpellData_sidecar_1.rogueSpellData.get();
    var _loop_1 = function (i) {
        var item = items[i];
        var ss = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(item.key);
        var color = (0, exports.getCanPurchaseColor)(item);
        var hotkey = item.hotkey; // !item.isBought ? item.hotkey : ''
        list.push({
            text: (hotkey ? hotkey + ':' : '') + ss.name,
            statsString: ss.statsString,
            description: item.desc,
            onSelect: function () {
                (0, exports.get)().selectedItem = item;
            },
            hotkey: item.isBought ? item.hotkey : '',
            color: color,
        });
    };
    for (var i = 0; i < items.length; i++) {
        _loop_1(i);
    }
    return list;
};
exports.getList = getList;
var drawAll = function () {
    _actionUsed = false;
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    (0, exports.moveSelection)(0, 0); // Reset wrap
    //  y++
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Upgrades sp:' + rogueStats_sidecar_1.rogueStats.getStats().skillPoints, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
    var list = (0, exports.getList)();
    if (!obj.selectedItem) {
        var _loop_2 = function (i) {
            var item = list[i];
            y++;
            var isHighlighted = i === obj.highlightedItemIdx;
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') + item.text, 
            //rogueDef.colors.light,
            item.color, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
                item.onSelect();
            }, function () {
                (0, exports.setSelection)(i);
            }, item.hotkey);
        };
        for (var i = 0; i < list.length; i++) {
            _loop_2(i);
        }
    }
    if (obj.selectedItem) {
        y++;
        y++;
        var si = obj.selectedItem;
        var actions = (0, exports.getActionList)(si);
        var ss = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(si.key);
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, si.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, si.desc, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark);
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, ss.statsString, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark);
        y++;
        var _loop_3 = function (i) {
            var action = actions[i];
            y++;
            var isHighlighted = i === obj.highlightedActionIdx;
            // let letter = alphabet[i]
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') +
                (action.letter ? action.letter + ':' : '') +
                action.name, action.color || rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
                (0, exports.setSelection)(i);
                (0, exports.select)();
            }, function () {
                (0, exports.setSelection)(i);
            }, action.letter);
        };
        for (var i = 0; i < actions.length; i++) {
            _loop_3(i);
        }
        // if (isHighlighted) {
        //   y++
        //   rogueMonofont.write(
        //     x + 1,
        //     y,
        //     ' ' + item.description,
        //     rogueDef.colors.light,
        //     rogueDef.colors.dark,
        //   )
        //   y++
        //   rogueMonofont.write(
        //     x + 1,
        //     y,
        //     item.statsString,
        //     rogueDef.colors.light,
        //     rogueDef.colors.dark,
        //   )
        //   //setTooltip(item.statsString, 1, 2)
        // }
        // y++
        // if (item.statsString) {
        //   rogueMonofont.write(
        //     x,
        //     y,
        //     item.statsString,
        //     //rogueDef.colors.light,
        //     item.color,
        //     rogueDef.colors.dark,
        //     () => {
        //       item.onSelect()
        //     },
        //     () => {
        //       setSelection(i)
        //     },
        //     item.hotkey,
        //   )
        // }
    }
    // if (obj.selectedItem) {
    //   let actions = getActionList(obj.selectedItem)
    //   rogueMonofont.write(x, y, rogueItems.getItemName(obj.selectedItem))
    //   y++
    //   for (let i = 0; i < actions.length; i++) {
    //     let action = actions[i]
    //     y++
    //     let isHighlighted = i === obj.highlightedActionIdx
    //     // let letter = alphabet[i]
    //     rogueMonofont.write(
    //       x,
    //       y,
    //       (isHighlighted ? '>' : ' ') + action.letter + ':' + action.name,
    //       rogueDef.colors.light,
    //       rogueDef.colors.dark,
    //       () => {
    //         setSelection(i)
    //         select()
    //       },
    //       () => {
    //         setSelection(i)
    //       },
    //       action.letter,
    //     )
    //   }
    // } else {
    //   for (let i = 0; i < inventory.length; i++) {
    //     let item = inventory[i]
    //     y++
    //     let isHighlighted = i === obj.highlightedItemIdx
    //     let letter = alphabet[i]
    //     rogueMonofont.write(
    //       x,
    //       y,
    //       (isHighlighted ? '>' : ' ') +
    //         letter +
    //         ':' +
    //         rogueItems.getItemName(item),
    //       rogueDef.colors.light,
    //       rogueDef.colors.dark,
    //       () => {
    //         setSelection(i)
    //         select()
    //       },
    //       () => {
    //         setSelection(i)
    //       },
    //       letter,
    //     )
    //   }
    // }
};
exports.drawAll = drawAll;
var getActionList = function (item) {
    var actions = [];
    if (!item.isBought) {
        var color = (0, exports.getCanPurchaseColor)(item);
        actions.push({
            color: color,
            name: 'Purchase ' + item.cost + ' sp',
            letter: 'a',
            action: function () {
                if (!item.isBought) {
                    if (rogueStats_sidecar_1.rogueStats.getStats().skillPoints >= item.cost) {
                        rogueStats_sidecar_1.rogueStats.getStats().skillPoints -= item.cost;
                        item.isBought = true;
                        //rogueSpellData.setSpellStats(item.key, ss)
                    }
                    (0, exports.setSelection)(0);
                }
            },
        });
    }
    else {
        actions.push({
            name: 'Purchased!',
            action: function () {
                var obj = (0, exports.get)();
                obj.selectedItem = null;
            },
        });
    }
    if (item.isBought) {
        var idx_1 = 1;
        item.upgrades.forEach(function (upgrade) {
            var colorUpgrade = (0, exports.getCanPurchaseColor)(upgrade);
            var name = upgrade.name;
            if (!upgrade.isBought) {
                name = '' + upgrade.cost + ' sp ' + name;
            }
            actions.push({
                name: name,
                action: function () {
                    if (!upgrade.isBought) {
                        if (rogueStats_sidecar_1.rogueStats.getStats().skillPoints >= upgrade.cost) {
                            rogueStats_sidecar_1.rogueStats.getStats().skillPoints -= upgrade.cost;
                            upgrade.isBought = true;
                            if (upgrade.key === 'max-uses') {
                                rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(item.key).baseSpell.usesLeft +=
                                    upgrade.effectAmount;
                            }
                            //rogueSpellData.setSpellStats(item.key, ss)
                        }
                    }
                    // setSelection(i)
                },
                color: colorUpgrade,
                letter: '' + idx_1,
            });
            idx_1++;
        });
    }
    actions.push({
        name: 'Back',
        letter: 'c',
        action: function () {
            var obj = (0, exports.get)();
            obj.selectedItem = null;
        },
    });
    actions.push({
        name: 'Done',
        letter: 'd',
        action: function () {
            (0, exports.close)();
        },
    });
    return actions;
};
exports.getActionList = getActionList;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    if (obj.selectedItem) {
        (0, exports.setSelection)(obj.highlightedActionIdx + oy);
    }
    else {
        (0, exports.setSelection)(obj.highlightedItemIdx + oy);
    }
};
exports.moveSelection = moveSelection;
var setSelection = function (selIdx) {
    var obj = (0, exports.get)();
    if (obj.selectedItem) {
        var actions = (0, exports.getActionList)(obj.selectedItem);
        obj.highlightedActionIdx = selIdx;
        obj.highlightedActionIdx = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlightedActionIdx, actions.length || 1);
    }
    else {
        obj.highlightedItemIdx = selIdx;
        // Wrap
        // let inventory = getInventory()
        // obj.highlightedItemIdx = mathUtils.betterMod(
        //   obj.highlightedItemIdx,
        //   inventory.length || 1,
        // )
    }
};
exports.setSelection = setSelection;
var select = function () {
    var obj = (0, exports.get)();
    var list = (0, exports.getList)();
    if (!obj.selectedItem) {
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (i === obj.highlightedItemIdx) {
                item.onSelect();
                return;
            }
        }
    }
    else {
        var actions = (0, exports.getActionList)(obj.selectedItem);
        var action = actions[obj.highlightedActionIdx];
        if (action) {
            if (!_actionUsed) {
                _actionUsed = true;
                console.log('doing upgrade action');
                //close()
                // obj.selectedItem = null
                action.action();
            }
        }
    }
};
exports.select = select;
var cancel = function () {
    (0, exports.close)();
};
exports.cancel = cancel;
